import React, { useEffect, useState } from "react";

// 一覧の軽量ページャー（クライアント側でページ分割）。
// サーバから取得済みの配列を pageSize ごとに区切り、1ページに収まらない（＝上限を超えた）ときだけ
// ページ送りUIを出す。何百件を一度に描画して重くなるのを防ぐのが目的。取得自体の上限はBE側の
// 返却上限（当org規模で十数年当たらない値）に委ねる＝将来それも超えるならサーバ側ページングへ。

// 1ページの表示件数。テーブル/カード一覧の標準的な1画面ぶん。
export const PAGE_SIZE = 50;

// rows を pageSize で分割し、現在ページぶんの pageRows を返すフック。
// 件数が減ってページが範囲外になったら自動で詰める（取消/承認で行が消えたとき等）。
export function usePager(rows, pageSize = PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(rows.length / pageSize));
  useEffect(() => { if (page > pageCount) setPage(pageCount); }, [page, pageCount]);
  const pageRows = rows.slice((page - 1) * pageSize, page * pageSize);
  return { page, setPage, pageRows, pageCount };
}

// ページ送りUI。1ページに収まる（pageCount<=1）なら何も出さない。
export default function Pager({ page, pageCount, onChange }) {
  if (!pageCount || pageCount <= 1) return null;
  const go = (p) => onChange(Math.min(pageCount, Math.max(1, p)));
  return (
    <nav className="mp-pager" aria-label="ページ送り">
      <button className="mp-btn mp-ghost mp-sm" onClick={() => go(page - 1)} disabled={page <= 1} aria-label="前のページ">‹ 前へ</button>
      <span className="mp-pager-info" aria-live="polite">{page} / {pageCount} ページ</span>
      <button className="mp-btn mp-ghost mp-sm" onClick={() => go(page + 1)} disabled={page >= pageCount} aria-label="次のページ">次へ ›</button>
    </nav>
  );
}
